// NPC Definitions - Helper utilities and zone-based NPC lookups
// Provides tileToWorld conversion and centralized NPC configuration access

import { NPCConfig } from './NPC';
import {
  OTAG_KOYU_NPCS, RUH_BATAKLIGI_NPCS,
  KARANLIK_ORMAN_NPCS, ERLIK_TAPINAGI_NPCS,
  ERGENEKON_GIRISI_NPCS, FIRTINA_OVASI_NPCS,
  ATES_MAGARASI_NPCS, YERSUB_TAHTI_NPCS,
  KARANLIK_TUNEL_NPCS, OLUM_NEHRI_NPCS,
  KEMIK_ORMANI_NPCS, LANETLI_SARAY_NPCS,
  ERLIK_KAPISI_NPCS, CEHENNEM_BAHCESI_NPCS,
} from './NPC';

// Tile-to-world conversion helper for isometric maps
// worldX = (tileX - tileY) * 32, worldY = (tileX + tileY) * 16
export function tileToWorld(tx: number, ty: number): { x: number; y: number } {
  return { x: (tx - ty) * 32, y: (tx + ty) * 16 };
}

// Re-export village NPC configs for direct access
export const VILLAGE_NPCS: NPCConfig[] = OTAG_KOYU_NPCS;

// Re-export swamp NPC configs for direct access
export const SWAMP_NPCS: NPCConfig[] = RUH_BATAKLIGI_NPCS;

// Zone-to-NPC mapping: all zone NPC arrays
const ZONE_NPC_MAP: Record<string, NPCConfig[]> = {
  'otag_koyu': OTAG_KOYU_NPCS,
  'ruh_batakligi': RUH_BATAKLIGI_NPCS,
  'karanlik_orman': KARANLIK_ORMAN_NPCS,
  'erlik_tapinagi': ERLIK_TAPINAGI_NPCS,
  'ergenekon_girisi': ERGENEKON_GIRISI_NPCS,
  'firtina_ovasi': FIRTINA_OVASI_NPCS,
  'ates_magarasi': ATES_MAGARASI_NPCS,
  'yersub_tahti': YERSUB_TAHTI_NPCS,
  'karanlik_tunel': KARANLIK_TUNEL_NPCS,
  'olum_nehri': OLUM_NEHRI_NPCS,
  'kemik_ormani': KEMIK_ORMANI_NPCS,
  'lanetli_saray': LANETLI_SARAY_NPCS,
  'erlik_kapisi': ERLIK_KAPISI_NPCS,
  'cehennem_bahcesi': CEHENNEM_BAHCESI_NPCS,
  // taht_odasi: no NPCs (final boss room)
};

// Get NPCs for a given zone ID
export function getZoneNPCs(zoneId: string): NPCConfig[] {
  return ZONE_NPC_MAP[zoneId] || [];
}

// Get all NPC configs across all zones
function getAllNPCs(): NPCConfig[] {
  const all: NPCConfig[] = [];
  for (const npcs of Object.values(ZONE_NPC_MAP)) {
    all.push(...npcs);
  }
  return all;
}

// Find an NPC config by ID across all zones
export function findNPCConfigById(npcId: string): NPCConfig | undefined {
  return getAllNPCs().find(npc => npc.id === npcId);
}

// Get all NPC IDs that are quest givers (have quests assigned to them)
export function getQuestGiverNPCIds(): string[] {
  return getAllNPCs().map(npc => npc.id);
}
